<template>
  <div class="collect-page">
    <div class="mains-content">
      <!-- <div class="right-box">
        <p class="shoping-titles">消费明细</p>
        <div class="contents-body">
          <el-row class="tables-title">
            <el-col :span="8" class="titles" >商品名称</el-col>
            <el-col :span="6" class="titles center" style="text-align: center;">剩余次数</el-col>
            <el-col :span="6" class="titles center" style="text-align: center;">划卡数量</el-col>
            <el-col :span="4" class="titles center" style="text-align: right;">删除</el-col>
          </el-row>
          <div class="tables scroll-auto">
            <div class="boxs" v-for="(item, index) in listSelected" :key="index">
              <el-row>
                <el-col :span="8" class="titles" >
                  {{ item.cardOldIdCn }}
                </el-col>
                <el-col :span="6" class="money center" style="text-align: center;">
                  {{ item.originNum - item.useNum }}
                </el-col>
                <el-col :span="6" class="nums center" style="text-align: center;">
                  <el-input-number v-model="item.consumeNum" @change="handleChangeNumber" :min="0" :max="item.originNum - item.useNum" @blur="blurItem(item)"></el-input-number>
                </el-col>
                <el-col :span="4" class="detail center" style="text-align: right;">
                  <i class="el-icon-delete delete" @click="deleteListSelected(item, index)"></i>
                </el-col>
              </el-row>
              <div class="right-content p10">
                <span class="staff-btn mr10" >服务技师</span>
                <span v-if="item.staffIds.length == 0" @click="setStaff(item, index)" class="shopClass">请选择></span>
                <span v-else  @click="setStaff(item, index)" class="shopClass">
                  {{staffName}}
                </span>
              </div>
            </div>
          </div>
          <div class="confirm-btn">
            <div class="flex-row space-between">
              <div class="msg">
                <div class="nums">
                  划卡次数:
                  <span class="moneys">{{ totalAmount }}</span>次
                </div>
              </div>
              <el-button type="primary" @click="saveMoney">确定划卡</el-button>
            </div>
          </div>
        </div>
      </div> -->
    <div class="page-left">
        <div class="member-box"><member ref="memberSearch" :mobile="formMobile" @handleChange="memberChange"></member></div>
        <div class="right-box">
          <div v-if="listSelected.length == 0 ? true:false" class="right-box-empty">
            <div class="right-box-empty-img">
              <img src="../../../assets/images/new/empty.png" alt="">
              <div class="color999 fontSize16 mt30">点击右侧卡片，进行划卡</div>
            </div>
          </div>
          <div v-else>
            <p class="shoping-titles">消费明细</p>
            <div class="contents-body">
            <el-row class="tables-title">
              <el-col :span="10" class="titles"><div class="goodName">商品名称</div></el-col>
              <el-col :span="5" class="titles center">剩余次数</el-col>
              <el-col :span="6" class="titles center">划卡数量</el-col>
              <el-col :span="3" class="titles right">操作</el-col>
            </el-row>
            <div class="tables p30 scroll-auto">
              <div class="boxs"
                v-for="(item, index) in listSelected"
                :key="index">
                <el-row>
                  <el-col :span="10" class="titles "><div class="goodName fb">{{
                    item.cardOldIdCn
                  }}</div></el-col>
                  <el-col :span="5" class="center fb">
                    {{ item.originNum - item.useNum }}
                    
                  </el-col>
                  <el-col :span="6" class="nums center fb fontSize18">
                    <span class="del-img" @click="blurItem('del',  item)">
                      <img src="../../../assets/images/new/del.png" alt="">
                    </span>
                    <el-input v-model="item.consumeNum" readonly="" size="mini" style="width: 40px;"></el-input>
                    <span class="del-img" @click="blurItem('add',item)">
                      <img src="../../../assets/images/new/add.png" alt="">
                    </span>
                  </el-col>
                  <el-col :span="3" class="titles center fb fontSize18"
                    >{{item.salePrice}}</el-col
                  >
                  <el-col :span="3" class="detail right">
                    <i
                      class="el-icon-delete delete"
                      @click="deleteListSelected(item, index)"
                    ></i>
                  </el-col>
                </el-row>
                <div class="right-content p10">
                  <span class="color666 fontSize16 mr10">服务技师 :</span>
                  <span
                    v-if="item.staffIds.length == 0"
                    @click="setStaff(item, index)"
                    class="shopClass"
                    >请选择></span
                  >
                  <span
                    v-else
                    @click="setStaff(item, index)"
                    class="shopClass"
                    >{{ staffName }}</span
                  >
                </div>
              </div>
            </div>
            <div class="confirm-btn">
              <div class="flex-row space-between">
                <div class="msg">
                  <div class="nums total">
                    划卡次数:
                    <span>{{totalAmount}}次</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
			  </div>
        <el-button class="save_btn" @click="saveMoney">确定划卡</el-button>
      </div>

      <div class="left-box">
        <div v-if="list.length > 0">
          <el-tabs v-model="active">
            <el-tab-pane label="全部" name="first"></el-tab-pane>
          </el-tabs>
          <div class="card-all scroll-auto">
            <div class="title-tabs">
              <div class="card-box" v-for="(item, index) in list" :key="index">
                <div @click="handleChangeList(item, index)">
                  <div class="card-msg">
                    <div class="flex-row block">
                      <p>{{ item.customerName }}({{ item.mobile }})</p>
                      <img src="../../../assets/images/new/payRadio.png"  v-if="item.flag" alt="" class="card_active">
                    </div>
                    <div class="card-msg-detail">
                      <div class="flex-row">
                        <p>编号：<span>{{ item.customerNo }}</span></p>
                        <p>登记次数：<span>{{ item.originNum }}</span></p>
                      </div>
                      <div class="flex-row">
                        <p>套餐<span>{{ item.cardOldIdCn }}</span></p>
                        <p>剩余次数：
                          <span class="money">
                            {{ item.originNum - item.useNum }}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="temporarilyNoData height_empy">
          <img src="../../../assets/images/new/recharge.png" alt="">
          <div class="color999 fontSize16 mt20">暂无数据</div>
        </div>
      </div>


      
    </div>
    <staff-set ref="staffSetForm" :isCashier="true" @staffChange="changePage"></staff-set>
    <pay-form ref="payEditForm" @payFun="payMoney" :hintName="'划卡成功'" :foot="true"></pay-form>
    <payDialog
      title="支付效验"
      :bizType="'cardReduce'"
      :hide="dialogHide"
      :mobile="$store.getters.MemberMobile"
      @changeDialog="dialogconfig"
    ></payDialog>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import staffSet from "../../components/staff-set";
import member from "../../components/noMember.vue";
import payForm from "../../components/pay";
import payDialog from "../../components/pay-dialog";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { staffSet, member, payForm, payDialog },
  data() {
    return {
      pageHeight: this.$store.getters.MainHeight,
      totalAmount: 0,
      img1: require("../../../assets/images/money/img1.png"),
      img2: require("../../../assets/images/money/img2.png"),
      img3: require("../../../assets/images/money/img3.png"),
      activeName: "serve",
      serveGoryName: "",
      dialogHide: false,
      serveGoryList: [], //服务分类
      list: [],
      productList: [],
      listSelected: [],
      staffName: "",
      form: {
        mobile: "",
        cardBookId: "",
        consumeNum: 0,
        staffIds: "",
        imgUrl: "",
        memberId: ""
      },
      url: this.$url.cardOldBook.page,
      query: {
        keyword: "",
        size: 20,
        start: 1
      },
      childForm: {},
      formMobile: "",
      active: "first"
    };
  },
  watch: {
    listSelected() {
      this.totalAmount = 0;
      for (let i in this.listSelected) {
        this.totalAmount = this.listSelected[i].consumeNum;
      }
    },
    list() {
      for (let i in this.list) {
        this.$set(this.list[i], "staffIds", []);
        this.$set(this.list[i], "consumeNum", 0);
      }
    }
  },
  created() {},
  methods: {
    dialogconfig() {},
    memberChange(value) {
      if (value == "") {
        this.listSelected = [];
        this.list = [];
        this.query.start = 1;
        this.query.keyword = "";
      } else {
        this.query.keyword = value;
        this.getList();
      }
      
    },
    handleChangeNumber() {
      this.totalAmount = 1;
      for (let i in this.listSelected) {
        this.totalAmount = this.listSelected[i].consumeNum;
      }
    },
    handleChangeList(item) {
      console.log(item);
      this.listSelected = [];
      this.list.map(it => {
        it.flag = false;
      })
      item.flag = true;
      this.listSelected.push(JSON.parse(JSON.stringify(item)));
    },
    deleteListSelected(item, index) {
      this.listSelected.splice(index, 1);
      this.list.map(it => {
        it.flag = false;
      })
    },
    setStaff(row, index) {
      this.$refs["staffSetForm"].$emit("set", {
        staffIds: row.staffIds,
        index: index
      });
    },
    changePage(org) {
      if (org.staffIds) {
        let arr = []
        org.staffIds.map(item => {
          arr.push(item.staffName)
        })
        this.staffName = arr.join(",") + ">"
        this.$set(this.listSelected[org.nodeId], "staffIds", org.staffIds);
      }
    },
    blurItem(type,item) {
      console.log(item);
      if (type == 'del') {
        if (item.consumeNum > 0) {
          item.consumeNum--;
          this.totalAmount--;
        };
      } else {
        if (item.consumeNum >= (item.originNum - item.useNum)) return
        item.consumeNum++;
        this.totalAmount++;
      }
		},
    payMoney(org) {
      if (org) {
        this.query.keyword = "";
        this.$refs.memberSearch.handleInputHide();
        this.listSelected = [];
        this.list  = [];
      }
    },
    saveMoney() {
      if (this.listSelected.length < 1) {
        this.$message.warning("请添加消费");
        return false;
      }
      if (this.totalAmount == 0) {
        this.$message.warning("划卡次数不能为0次");
        return false;
      }
      for (let i in this.listSelected) {
        if (this.listSelected[i].staffIds.length < 1) {
          this.$message.warning(
            this.listSelected[i].cardOldIdCn + " 请选择技师"
          );
          return false;
        }
      }

      let arrIds = "",
        arrNames = "";
      for (let i in this.listSelected) {
        for (let j in this.listSelected[i].staffIds) {
          if (j == 0) {
            arrIds = this.listSelected[i].staffIds[j].staffId;
            arrNames = this.listSelected[i].staffIds[j].staffName;
          } else {
            arrIds += "," + this.listSelected[i].staffIds[j].staffId;
            arrNames += "," + this.listSelected[i].staffIds[j].staffName;
          }
        }
      }
      this.form.staffIds = arrIds;
      this.form.staffNames = arrNames;
      this.form.cardBookId = this.listSelected[0].id;
      let arr = {
        mobile: this.form.memberId ? this.$store.getters.MemberMobile : "",
        cardBookId: this.listSelected[0].id,
        consumeNum: this.listSelected[0].consumeNum,
        staffIds: arrIds,
        staffNames: arrNames,
        imgUrl: ""
      };
      this.$api.post(this.$url.cardOld.cardReduce, arr).then(res => {
        if (res) {
          this.dialogHide = false;
          this.$refs["payEditForm"].$emit("set", res);
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
.block {
  width: 100%;
  font-size: 18px;
  font-weight: 700;
}
/deep/ .el-tabs__nav-wrap {
  padding: 0 16px;
  .el-tabs__item {
    height: 48px;
    line-height: 48px;
    font-size: 18px;
  }
}
.mains-content {
  display: flex;
  height: 100%;
  .left-box {
    width: 60%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .tops-title {
      width: 100%;
      padding: 0 25px;
      box-sizing: border-box;
      p {
        font-size: 18px;
        font-weight: 500;
        height: 53px;
        line-height: 53px;
        border-bottom: 1px solid @borderColor;
        span {
          color: @blue;
        }
      }
    }
    .card-all {
      height: 585px;
      .title-tabs {
        display: flex;
        flex-wrap: wrap;
        padding: 16px;
      }
    }
    .card-box {
      width: calc((99% / 2) - 34px);
      padding: 16px;
      margin-right: 1%;
      margin-bottom: 20px;
      position: relative;
      background-color: #ecf6ff;
      border: 1px solid #D2E5FF;
      border-radius: 4px;
      &:nth-of-type(2n) {
        margin-right: 0 !important;
      }
      .card_active {
        position: absolute;
        top: 0;
        right: 0;
      }
      .card-msg {
        font-weight: 500;
        color: #333;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .card-msg-detail {
          width: 100%;
          font-size: 16px;
          color: #666;
          margin-top: 50px;
          .flex-row {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 18px;
            p {
              &:first-child {
                width: 60%;
              }
              &:last-child {
                flex: 1;
              }
              .money {
                color: @money;
                font-size: 16px;
                font-weight: 500;
              }
            }
          }
        }
      }
      .active {
        color: #333;
        .money {
          color: @money;
        }
      }
    }
    .notMargin {
      margin-right: 0;
    }
  }
}
</style>

<style lang="less" scoped>
.collect-page {
  height: calc(100vh - 58px);
  background-color: #e6edf5;
  padding: 16px;
  .groupDialog /deep/ .el-dialog__body {
    padding: 10px 20px;
    color: #111;
    height: 200px;
    overflow: auto;
  }
}
.box-active {
    height: 435px !important;
  }
  .member-box {
    width: calc(100% - 48px);
    padding: 9px 16px;
    background: #3388ff;
    border-radius: 10px 10px 0px 0px;
	}
  .right-box {
		background: url("../../../assets/images/new/footBath.png") no-repeat;
    background-position:center bottom;
    height: calc(100vh - 248px);
    margin-right: 16px;
		.right-box-empty {
      height: calc(100vh - 248px);
      display: flex;
      justify-content: center;
      align-items: center;
      .right-box-empty-img {
        width: 191px;
        height: 170px;
      }
    }
		.shoping-titles {
			padding: 16px;
			font-size: 18px;
			font-weight: 700;
		}
		.contents-body {
			.tables-title {
        padding: 13px 16px;
        font-size: 14px;
        background: #F7F8FA;
			}
			.tables {
				padding: 0 0 16px;
				height: calc(100vh - 430px);
				box-sizing: border-box;
				.boxs {
					padding: 18px 16px 0;
					box-sizing: border-box;
		
					.delete {
						font-size: 18px;
						cursor: pointer;
						&:hover {
							// color: @blue;
						}
					}
				}
				.right-content {
					margin-top: 15px;
					display: flex;
          padding-bottom: 16px;
          border-bottom: 1px solid #EBEDF0;
				}
			}
			.confirm-btn {
				display: flex;
				align-items: center;
				margin: 0 16px;
				border-top: 1px solid #EBEDF0;
				padding: 12px 0;
				.flex-row {
					width: 100%;
					align-items: center;
          
					.msg {
            width: 100%;
						display: flex;
            justify-content: flex-end;
						font-weight: 500;
						.nums {
              line-height: 3;
							margin-right: 40px;
						}
					}
				}
			}
      
		}
	}
.page-left {
  width: 40%;
}
.box-actives {
  border: 1px solid #F9AA6C !important;
}
.save_btn {
  width: calc(100% - 16px);
  height: 68px;
  font-size: 20px;
  font-weight: bold;
  margin-top: 15px;
  color: #fff;
  background: #FF5449;
}
.goodName {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.nums {
  display: flex;
  justify-content: center;
  .del-img {
    width: 28px;
    height: 28px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  /deep/ .el-input__inner {
    border-radius: inherit;
    text-align: center;
    padding: 0;
    border-left: none;
    border-right: none;
  }
}
.height_empy {
  height: calc(100vh - 200px);
}
</style>